<template>
  <BaseCard noPadding>
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:text-gray-800 tw:p-5">
      <div class="tw:flex tw:justify-between tw:w-full tw:flex-col">
        <div class="tw:mb-5">
          <p class="tw:text-xl tw:font-bold">{{ $t('form.info.title_manage_user') }}</p>
        </div>
        <div>
          <UserRolesTable />
        </div>
      </div>
    </div>
  </BaseCard>
</template>
<script setup>
import UserRolesTable from './UserRolesTable.vue'
import BaseCard from '@/components/dashboard/BaseCard.vue'
</script>
